import { useState, useEffect } from "react";
import "../Css/Testimonials.css";

const testimonials = [
  {
    text: `An excellent Physics faculty with deep conceptual understanding and a very student-friendly approach. Every topic is explained from the basics, with real-life examples that make learning easier. Doubts are cleared patiently, and the way he simplifies tough derivations is truly impressive. Highly recommended for anyone wanting strong fundamentals in Physics.`,
    name: "Shilpi Kumari",
  },
  {
    text: `I joined this academy for Jee Advanced coaching in Vadodara and my experience has been really good. The teachers explain concepts clearly, clear doubts patiently, and focus a lot on problem-solving. The study material and regular tests helped me gain confidence and improve my performance.`,
    name: "Mahi Mankodi",
  },
  {
    text: `Excellent support system for students. Even during late hours, the academy provides resources that help in self-study. Their reputation as a leading IIT JEE coaching center in Vadodara is well-deserved.`,
    name: "Raj Ram",
  },
  {
    text: `BEST JEE COACHING IN VADODARA!!
           I joined the coaching about 6 months ago and have been noticing upward trend in my academics. The teachers pay personal attention to you for your quaries.`,
    name: "Sanwar Bhatia",
  },
  {
    text: `Amazing teaching methods!! Hats off to the faculty for taking ownership and responsibility for the kids' development ☺️
           One of the best IIT JEE coaching centres in Vadodara. Recommended!`,
    name: "Mamta Bajpai",
  },
  {
    text: `BEST IIT JEE coaching in Vadodara
           In my experience, this is the BEST IIT JEE coaching in Vadodara. The faculty is knowledgeable, study material is well-designed, and the competitive environment motivates students to work harder every day.`,
    name: "Vanshika Patil",
  },
  {
    text: `I am a student of Chinmay Academy and I joint it in class IX to prepare for my 10th and 12th Boards as well as various competitive exams like NEET and AIIMS. I secured 92% in 10th Board. The faculty at Chinmay Academy helped me with not only my academics but also provided Emotional support and motivation. In class 10th I focused only on my boards and manage to secure considerably good percentage. Thanks to my teachers!! Chinmay's regular tests and evaluation system kept me up to date with my progress. I never faced any time management issues. Thanks to the tips given by my teachers at Chinmay. The faculty is friendly and supportive and has helped me through all my ups and downs. I dedicate all my success to Chinmay Academy.`,
    name: "Suhasini Sudan",
  },
  {
    text: `I joined IITians Chinmay Academy in 2020 as a 12th pass out. My aim was to bag a decent rank in JEE Mains and Advance examination 2021. Though physics was my major subject of concern, teachers here helped me grasp the concepts with crystal clear clarity. Their concern goes beyond academics including motivation, strategy building and student wellbeing. This surely makes this academy unique.`,
    name: "Animesh Agarwal",
  },
  {
    text: `I can’t thank Asit Sir and Dhruv Sir enough for their tremendous support through my preparations for JEE. They didn’t just teach but ensured that I was always motivated. Their regular evaluation helped me work on my weaknesses and boosted my confidence even during Covid-19.`,
    name: "Rishabh Shah",
  },
  {
    text: `With an out of the box approach and personalised attention, Asit sir explains physics in a way that stays with you forever. His classes are stress free, engaging and focused on understanding rather than rote learning.`,
    name: "Uttkarsh Iyer",
  },
  {
    text: `I joined IITians Chinmay Academy to strengthen my physics for NEET. Asit sir gave me personal attention and helped me build strong concepts. He changed my fear of physics into confidence.`,
    name: "Nidhi Joshi",
  },
  {
    text: `Best JEE coaching in Vadodara!! My kids are showing immense improvement. A big shout-out to Asit sir, Amrita mam and team for their dedication towards their students and their fun way of teaching. Keep up the good work!!`,
    name: "Neha Bajpai",
  },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  // 🔥 AUTO SCROLL
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 4000); // ⏱ 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">

        <h2>Testimonials</h2>

        {/* CARD */}
        <div className="testimonial-card">
          <div className="quote-icon">“</div>

          <p className="testimonial-text">
            {testimonials[index].text}
          </p>

          <h4 className="testimonial-name">
            {testimonials[index].name}
          </h4>
        </div>

        {/* DOTS */}
        <div className="testimonial-dots">
          {testimonials.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
